import React, { useState } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import icTitle from "../../../assets/images/ic-play.svg";
import ENGModalBody from "../../../components/modal/ENGModalBody";
import ENGModalFooter from "../../../components/modal/ENGModalFooter";
import ENGModalHeader from "../../../components/modal/ENGModalHeader";
import SearchBar from "../../../components/searchbar/SearchBar";
import VideoItem from "../sections/VideoItem";
import InfiniteScroll from "react-infinite-scroll-component";

import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import {
  GetAwarenessModule,
  selectAwarenessModule,
} from "../../../features/learning/AwarenessSlice";
const VideosModal = ({ records }: { records: any }) => {
  const [modalShow, setModalShow] = useState(false);

  const handleClose = () => setModalShow(false);
  const handleShow = () => setModalShow(true);
  const AwarenessModule = useAppSelector(selectAwarenessModule);
  const dispatch = useAppDispatch();
  const [ofset, setOfset] = useState(0);
  const fetchMoreData = () => {
    // a fake async api call like which sends
    // 10 more records in 1.5 secs

    setTimeout(() => {
      records = AwarenessModule.concat(Array.from({ length: 10 }));
      //var ofset=1
      async function fetchLearningModuleData() {
        let sample = await dispatch(GetAwarenessModule(ofset + 1));
        setOfset((prev) => prev + 1);
      }
      fetchLearningModuleData();
    }, 1500);
  };
  return (
    <>
      <a
        onClick={handleShow}
        style={{
          backgroundColor: "#fff",
          color: "#e31837",
          fontFamily: "Saira",
          fontWeight: 600,
          fontSize: "12px",
          textTransform: "uppercase",
        }}
      >
        {/* <b>
          VIEW ALL
          <span style={{ fontSize: "18px" }}>{" >"}</span>
        </b>         */}
      </a>

      <Modal
        show={modalShow}
        onHide={handleClose}
        backdrop="static"
        size="lg"
        keyboard={false}
      >
        <ENGModalHeader icon={icTitle} title="Videos" />
        <ENGModalBody
          contents={
            <>
              <Row className="mt-3 me-1 desk">
                <Col xs={12} sm={6} className="pe-3 ms-auto">
                  <SearchBar />
                </Col>
              </Row>
              <Row className="mt-3 mob">
                <Col
                  xs={12}
                  sm={6}
                  style={{ paddingLeft: "30px", paddingRight: "30px" }}
                >
                  <SearchBar />
                </Col>
              </Row>
              <InfiniteScroll
                dataLength={records.length}
                next={fetchMoreData}
                hasMore={true}
                height={500}
                loader={<h5>Loading...</h5>}
              >
                <Row style={styles.divWhite}>
                  {records.map((item: any) => (
                    <VideoItem item={item} columns={6} />
                  ))}
                </Row>
              </InfiniteScroll>
            </>
          }
        />
        <ENGModalFooter closeMethod={handleClose} />
      </Modal>
    </>
  );
};

const styles: any = {
  divGrey: {
    backgroundColor: "#faf9f9",
    paddingTop: "40px",
    paddingLeft: "40px",
  },
  divWhite: {
    backgroundColor: "#fffff",
    paddingTop: "24px",
    paddingLeft: "20px",
    paddingRight: "20px",
  },
  bgGrey: {
    backgroundColor: "#faf9f9",
  },
  p0: {
    padding: "0px",
  },
  continue: {
    float: "right",
    textAlign: "right",
    fontFamily: "Saira",
    fontSize: "12px",
    fontWeight: 600,
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: 2,
    letterSpacing: "normal",
  },
  name: {
    fontFamily: "Saira",
    fontSize: "18px",
    fontWeight: "600",
    fontStrech: "normal",
    textAlign: "left",
    marginTop: "32px",
  },
  designation: {
    fontFamily: "Saira",
    fontSize: "18px",
    fontWeight: "normal",
    fontStrech: "normal",
    textAlign: "left",
    marginBottom: "32px",
  },
  message: {
    fontFamily: "Saira",
    fontSize: "18px",
    fontWeight: "normal",
    fontStrech: "normal",
    textAlign: "left",
  },
};

export default VideosModal;
